import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  height: 100%;
`;

export const StateContainer = styled.div`
  .instruction {
    width: 452px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border: 2px solid ${colors.green};
    padding: 46px 24px;

    .icon {
      width: 40px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      font-size: 22px;
      font-weight: 600;
      text-align: center;
      color: ${colors.white};
      margin: 30px 0 0 0;
    }

    .text {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      color: ${colors.white};
      margin: 30px 0 0 0;
    }
  }
`;

export const Content = styled.div`
  width: 500px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .text {
    color: ${colors.white};
    margin: 25px 0 15px 0;
  }
`;

export const Footer = styled.div`
  width: 500px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-top: 24px;

  .buttonContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .back {
      font-size: 18px;
      font-weight: 700;
      margin-right: 30px;
      color: ${colors.lightBlue};
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
